import mainMenu from '@/components/mainMenu/index.vue';
import settingsMenu from '@/components/settingsMenu/index.vue';
import preloader from '@/components/preloader/index.vue';

import Api from '@/utils/api';

import {
  ROLE_SYSTEM_ADMIN,
  DEFAULT_IMAGE,
} from '@/utils/const';

export default {
  components: {
    mainMenu,
    settingsMenu,
    preloader,
  },
  data () {
    return {
      user: {},
      accounts: [],
      defaultImage: DEFAULT_IMAGE,
      roleAdmin: ROLE_SYSTEM_ADMIN,
    };
  },
  watch: {
    '$route' (to, from) {
      this.$store.dispatch('SHOW_SETTINGS_MENU', false);
      this.resizeWindow();
    },
  },
  created () {
    this.$on('updateUser', (data) => this.getUser());
    this.getUser();

    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.resizeWindow();
      });
    });
  },
  methods: {

    resizeWindow () {
      var w = window.innerWidth;

      if (w <= 1366 || w != window.innerWidth) {
        this.$store.dispatch('SHOW_MENU', false);
      } else {
        this.$store.dispatch('SHOW_MENU', true);
      }

      if (w <= 1000 || w != window.innerWidth) {
        this.$store.dispatch('SHOW_FILTER', false);
      } else {
        this.$store.dispatch('SHOW_FILTER', true);
      }
    },

    /**
         * Hide additional menu for admins
         */
    hideMenu () {
      if (this.$store.getters.showSettingsMenu) {
        this.$store.dispatch('SHOW_SETTINGS_MENU', false);
      }
    },

    getUser () {
      this.$store.dispatch('SHOW_PRELOADER', true);

      Api.user
        .get()
        .then((response) => {
          if (response.data.Status) {
            this.user = response.data.Data;

            this.$store.dispatch('SET_USER', this.user);
            this.$store.dispatch('UPLOAD_PERMISSIONS');
            this.$store.dispatch('CHECK_ALIVE');
            this.getUserAccount();
          } else {
            this.$store.dispatch('LOGOUT');
          }
        });
    },

    getUserAccount () {
      Api.user
        .getAccounts()
        .then((response) => {
          if (response.data.Status) {
            this.accounts = response.data.Data;
          }

          this.$store.dispatch('SHOW_PRELOADER', false);
        });
    },
  },
};
